import API from './apiConfig';

export const getAccommodationForm = async () => {
  const id = localStorage.getItem("username")
    ? JSON.parse(localStorage.getItem("username"))
    : "0000";
  try {
    const response = await API.get(`/accommodation/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const postAccomodationById = async (formData) => {
  const id = localStorage.getItem("username")
    ? JSON.parse(localStorage.getItem("username"))
    : "0000";
  try {
    const response = await API.post(`/accommodation/${id}`, formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching student ${id}:`, error);
    throw error;
  }
};

export const updateAccommodationById = async (formData) => {
  const id = localStorage.getItem("username")
    ? JSON.parse(localStorage.getItem("username"))
    : "0000";
  try {
    const response = await API.put(`/accommodation/${id}`, formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching student ${id}:`, error);
    throw error;
  }
};

export const topUpAndRefund = async (formData) => {
  const id = localStorage.getItem("username")
    ? JSON.parse(localStorage.getItem("username"))
    : "0000";
  try {
    const response = await API.put(`/topup_and_refund/${id}`, formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching student ${id}:`, error);
    throw error;
  }
};

export const fetchPaymentIntent = async (formData) => {
  try {
    const response = await API.post(`/create-payment-intent`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};